import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import { setInputModal } from '../actions/modalActions'
import { toggleKeyboard } from '../../actions/layoutActions'
import { setMessageModal } from '../../actions/generalActions'
import { getTranslation } from '../../actions/dataActions'
import PropTypes from 'prop-types'
import $ from 'jquery'
import * as resource from '../../constants/Resources'

class InputModal extends Component {
  constructor(props) {
    super(props);

    this.cancelTap = this.cancelTap.bind(this);
    this.processTouchTap = this.processTouchTap.bind(this);
    this.keyPressed = this.keyPressed.bind(this);
    this.showKeyboard = this.showKeyboard.bind(this);
    this.updateInputField = this.updateInputField.bind(this);

    this.state = {
      inputField: ''
    };
  }

  showKeyboard() {
    this.setState({ inputField: '' });
    const msg = this.props.inputModal.message;
    this.props.toggleKeyboard(true, '#input', msg || this.props.getTranslation(resource.INVOICE_REFERENCE), this.updateInputField, [$('#input').val()]);
  }

  updateInputField(input) {
    this.setState({ inputField: input });
  }

  cancelTap() {
    this.props.setInputModal(false, 'default');
  }

  keyPressed(event) {
    if (event.key === "Enter") {
      this.processTouchTap();
    }
  }

  processTouchTap() {
    const input = $('#input').val();

    if (input.trim() === "") {
      this.props.setMessageModal(true, this.props.getTranslation(resource.INPUT_EMPTY_MESSAGE));
      return;
    }

    const callback = this.props.inputModal.callback;
    const dispatch = this.props.inputModal.dispatch;

    let callbackParams = [input];

    if (this.props.inputModal.callbackparams !== undefined) {
      this.props.inputModal.callbackparams.map(param => {
        callbackParams.push(param);
        return '';
      })
    }

    this.props.setInputModal(false, 'default');

    if (callback !== null) {
      if (dispatch !== null) {
        dispatch(callback.apply(this, callbackParams));
      } else {
        callback.apply(this, callbackParams);
      }
    }
    $('#input').val('');
    this.setState({ inputField: '' });
  }

  render() {
    return (
      <Modal className="inputModal"
        contentLabel=""
        isOpen={!!this.props.inputModal.show}
        style={properties.inputModalStyle}
      >
        <div className="inputModal_header">
          <div className="header_top">
            {this.props.inputModal.message}
          </div>
        </div>
        <div className="inputModal_content">
          <input
            id="input"
            className="inputModal_input"
            type="text"
            placeholder={this.props.inputModal.placeholder}
            onKeyPress={this.keyPressed}
            onClick={this.showKeyboard}
            autoFocus={true} />
        </div>
        <div className="inputModal_footer">
          <button className="btnCancel" onClick={this.cancelTap} >
            {this.props.getTranslation(resource.CANCEL)}
          </button>
          <button className="btnApprove" onClick={this.processTouchTap} >
            {this.props.getTranslation(resource.SAVE)}
          </button>
        </div>
      </Modal>
    )
  }
}

InputModal.propTypes = {
  inputModal: PropTypes.object.isRequired,
  setInputModal: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    inputModal: state.modalState.inputModal,
  }
}

export default connect(mapStateToProps, {
  setInputModal,
  toggleKeyboard,
  setMessageModal,
  getTranslation
})(InputModal)



// WEBPACK FOOTER //
// src/modal/components/InputModal.jsx